import { render, staticRenderFns } from "./UploadOne.vue?vue&type=template&id=5081bdb2&"
import script from "./UploadOne.vue?vue&type=script&lang=js&"
export * from "./UploadOne.vue?vue&type=script&lang=js&"
import style0 from "./UploadOne.vue?vue&type=style&index=0&id=5081bdb2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports